import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./SearchBar.module.css";

/**
 * Interactive component. A search bar.
 */

export function SearchBar({ placeholderText, onInput, searchDelay, minChar }) {
  const [input, setInput] = useState("");

  // useEffect(() => {
  //   if (input.length >= minChar) {
  //     const timer = setTimeout(() => {
  //       onInput(input);
  //     }, searchDelay);

  //     return () => clearTimeout(timer);
  //   }
  // }, [input, onInput, searchDelay, minChar]);

  return (
    <>
      <div className={styles.container}>
        <input
          type="text"
          id="search-bar"
          placeholder={placeholderText}
          className={styles.searchInput}
          onChange={(key) => onInput(key.target.value)}
        />
      </div>
    </>
  );
}

SearchBar.propTypes = {
  // Input placeholder text.
  placeholderText: PropTypes.string,

  // Function that fires on keystroke.
  onInput: PropTypes.func,

  // An optional delay in ms before onInput is fired.
  searchDelay: PropTypes.number,

  // Minimum characters that need to be exceeded before onInput is fired.
  minChar: PropTypes.number,
};

SearchBar.defaultProps = {
  // Default delay of 0
  searchDelay: 0,

  // Default minChar of 0
  minChar: 0,
};
